import { render, staticRenderFns } from "./adDisplayPageComponentNews.vue?vue&type=template&id=662f5b00&scoped=true&"
import script from "./adDisplayPageComponentNews.vue?vue&type=script&lang=js&"
export * from "./adDisplayPageComponentNews.vue?vue&type=script&lang=js&"
import style0 from "./adDisplayPageComponentNews.vue?vue&type=style&index=0&id=662f5b00&prod&lang=css&"
import style1 from "./adDisplayPageComponentNews.vue?vue&type=style&index=1&id=662f5b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662f5b00",
  null
  
)

export default component.exports